import { Table } from "antd";
import { tableDoDontSchema, tableSchema } from "../../../services/Item";
import { ColumnsType } from "antd/es/table";
import './tableDetails.css';

interface TableDetailsProps<T> {
    dataSource: T[],
    columns: ColumnsType<T>,
    title: string
}

const TableDetails = <T extends tableSchema | tableDoDontSchema>({ dataSource, columns, title }: TableDetailsProps<T>) => {
    return (
        <>
            {dataSource.length !== 0 && (
                <>
                    <div className="table-details-title" id={title}>{title}</div>
                    <Table
                        dataSource={dataSource}
                        columns={columns}
                        size="small"
                        pagination={false}
                        bordered
                        rowKey='_id'
                    />
                </>
            )}
        </>
    );
};

export default TableDetails;